import { E_RISK_TYPE, IActiveCountryMap, VIEW } from 'interfaces';
import React from 'react';
import GQMapProvider from 'components/GQMap/GQMapProvider';
import useInitCountryDim from 'hooks/useInitCountryDim';
import { CrossCountryRiskPage } from 'components/Pickers/CrossCountryRiskPicker';
import { inject } from 'mobx-react';
import { IMobxRootState } from 'RootStore';
import { SortByDeltaLegend } from './SortByDeltaLegend';

export const SortByDeltaPage = React.memo(() => {
    return (
        <CrossCountryRiskPage>
            <SortByDelta />
        </CrossCountryRiskPage>
    );
});

type SortByDeltaProps = {
    selectedCountries?: number[];
    licencedCountries?: IActiveCountryMap;
};

export const SortByDelta = inject(({ countryStore }: IMobxRootState) => {
    return {
        selectedCountries: countryStore.currentCountryList,
        licencedCountries: countryStore.countries.licensedCountries,
    };
})(
    React.memo((props: SortByDeltaProps) => {
        const ready = useInitCountryDim({
            riskType: E_RISK_TYPE.DIMENSIONS,
            multiCountry: true,
            multiRisk: false,
        });

        if (!ready) return null;
        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    position: 'relative',
                }}>
                <div
                    style={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                    <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                        <GQMapProvider view={VIEW.SORT_BY_DELTA} />
                    </div>
                    <SortByDeltaLegend
                        selectedCountries={props.selectedCountries}
                        licencedCountries={props.licencedCountries}
                    />
                </div>
            </div>
        );
    })
);
